import { ProductResult } from '@shared/api/types';
import { Icons } from '@shared/components/content/icons';
import Text from '@shared/components/content/text';
import ProductPackagingTable from './product-packaging-table';

interface ProductDetailPackagingSectionProps {
  product: ProductResult;
  globalMaxEmissions: number;
}

export default function ProductDetailPackagingSection({
  product,
  globalMaxEmissions,
}: ProductDetailPackagingSectionProps) {
  const { packaging } = product;

  if (product.totalEmissions == null || !packaging.packagingTypes?.length)
    return null;

  const share = (packaging.packagingEmissions / product.totalEmissions) * 100;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <Text variant="cardTitle" className="text-primary-900">
            Packaging
          </Text>
        </div>
        <div className="flex space-x-6">
          <span className="flex items-center space-x-1 text-right font-medium text-teal-600">
            <Icons.pieChart size={16} />
            <Text>{share.toFixed(1)}% of total emissions</Text>
          </span>
        </div>
      </div>
      <ProductPackagingTable
        packagingTypes={packaging.packagingTypes || []}
        maxEmissions={globalMaxEmissions}
        totalEmissions={product.totalEmissions!}
        product={product.name}
      />
    </div>
  );
}
